import { Injectable } from '@angular/core';
import { AppConfigService } from '../../app.config.service';

@Injectable()
export class InterceptorService {
  constructor(private appConfigService: AppConfigService) {}

  skipInterceptor(url?: string) {
    if (!this.appConfigService?.settings) {
      return false;
    }
    const skipUrl = [this.appConfigService.settings.draftBucketURL, this.appConfigService.settings.finalBucketURL];
    return !!skipUrl.some((eachUrl) => url.includes(eachUrl));
  }

  public redirect(url: string): void {
    window.location.replace(url);
  }
}
